import React from 'react'
import socketIo from 'socket.io-client';
 
//'https://tripendardemo.herokuapp.com', //, //
const url = process.env.REACT_APP_SOCKET_URL || 'http://Tripendarbackend-env.eba-ip7qrgmm.us-east-1.elasticbeanstalk.com'
export const socket = socketIo(url, { transports : ['websocket', 'polling', 'flashsocket'] });
export const socketContext = React.createContext()
 